import { Implantation } from "@model/implantation";

export interface ImplantationDto {
  id: string;
  fase: number;
  niveauEnseignement: string;
}

export const ImplantationDtoMapper = {
  toDomain: (dto: ImplantationDto): Implantation => ({
    id: dto.id,
    fase: dto.fase,
    educationLevel: dto.niveauEnseignement,
  })
};